/** @format */

import { AxiosError, AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../constants/api";
import apiClient from "../../utils/apiClient";

export const apiBrandList = (): Promise<{ response?: AxiosResponse; error?: AxiosError }> =>
  apiClient
    .get(API_ENDPOINTS.BRAND_LIST)
    .then(response => ({ response }))
    .catch(error => ({ error }));
